const $ = jQuery.noConflict();

const heroSlider = {
    heroSlider : $('.block-hero-slider__slider-wrapper'),

    initSlider(){
        $(this).slick({
            slide : '.block-hero-slider__item',
            dots: true,
            appendDots: $(this).parent().find('.controls-wrapper'),
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade : true,
            pauseOnHover : false,
            autoplay : true,
            autoplaySpeed: 5000,
        });
    },
    init(){
        if( this.heroSlider ){
            this.heroSlider.each( this.initSlider );
        }
    }
}

export default heroSlider;